import Vue from "vue";
import Router from "vue-router";
import VueMeta from "vue-meta";
import { routes } from "./routes";

Vue.use(Router);

Vue.use(VueMeta);

// console.log(routes);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior() {
    // return desired position
    return { x: 0, y: 0, behavior: "smooth" };
  }
});

// router.beforeEach((to, from, next) => {
// const section = "default";

// if (to.matched.some(record => record.meta.section)) {
// }
//   next(); // make sure to always call next()!
// });

export default router;
